// extracted by mini-css-extract-plugin
export default {"clickable":"ColoredText_clickable__jogbg"};